export enum EBillingPlan {
  BASIC = "basic",
  TRADER = "trader",
  PRO = "pro",
  EXPERT = "expert",
}
